import { render, staticRenderFns } from "./CompOrderModal.vue?vue&type=template&id=ff7f3022"
import script from "./CompOrderModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompOrderModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports